<template>
  <div>
    <div v-if="mainGrammar !== 'Edit'">
      <div
        :class="
          !currentField.file || !currentField.file.fileUrl
            ? `upload-file`
            : null
        "
      >
        <strong
          class="my-auto"
          v-if="!currentField.file || !currentField.file.fileUrl"
          >挿絵データ</strong
        >
      </div>
      <v-img
        v-if="currentField.file && currentField.file.fileUrl"
        :lazy-src="currentField.file ? currentField.file.fileUrl : null"
        :src="currentField.file ? currentField.file.fileUrl : null"
        height="auto"
        max-width="338"
        aspect-ratio="1.7"
        contain
      />
    </div>
    <base-upload type="image" v-else v-model="currentField.file">
      <div
        slot="activator"
        :class="
          !currentField.file || !currentField.file.fileUrl
            ? `upload-file`
            : null
        "
      >
        <strong
          class="my-auto"
          v-if="!currentField.file || !currentField.file.fileUrl"
          >挿絵データ</strong
        >
        <v-img
          v-if="currentField.file && currentField.file.fileUrl"
          :lazy-src="currentField.file ? currentField.file.fileUrl : null"
          :src="currentField.file ? currentField.file.fileUrl : null"
          height="auto"
          aspect-ratio="1.7"
          contain
        />
      </div>
    </base-upload>
  </div>
</template>


<script>
export default {
  store: ["mainGrammar"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  methods: {},
};
</script>
<style scoped>
.upload-file {
  text-align: center;
  min-height: 130px;
  border: 2px dashed #20a8d8;
  display: flex;
  justify-content: center;
}
strong {
  user-select: none;
}
</style>
